import { ref, computed } from '@vue/composition-api'
import { fetchRsOrderDetail } from '@ms/api/order'

export default function useOrderDetail() {
  // 订单详情
  const resOrderDetail = ref({})

  const isWon = computed(() => [20, 40].includes(resOrderDetail.value.winningStatus))
  const isLost = computed(() => resOrderDetail.value.winningStatus === 30)
  const settled = computed(() => ![-1, 0, 10].includes(resOrderDetail.value.winningStatus))

  // 设置用户的订单详情
  const setOrderdetail = (obj) => {
    resOrderDetail.value = obj
  }

  /**
   * 获取用户的 realsport / virtual 订单详情
   * @return {Object} {} 订单详情
   */
  async function getOrderDetail(orderId = '') {
    const data = await fetchRsOrderDetail(orderId)
    setOrderdetail(data)
    // 其他地方会用到返回值
    return data
  }

  return {
    resOrderDetail,
    getOrderDetail,
    isWon,
    isLost,
    settled
  }
}
